module.exports = __webpack_public_path__ + "img/about-us-dark.5670d9c6.svg";